import { useEffect } from "react"

import Firebase from "#classes/Firebase"
import {
  calendarFromDocs,
  installSemesterCalendar,
} from "#utils/semesterCalendar"

// Plain semester helpers cannot call a hook. This installs the Firestore list
// for them, and leaves the hardcoded starts in place when the collection is
// empty, missing any seed semester, or the listener fails.
export const useSemesterCalendar = (): void => {
  useEffect(() => {
    return Firebase.getInstance().listenSemesterCalendar(
      (docs) => {
        installSemesterCalendar(calendarFromDocs(docs))
      },
      (error) => {
        console.error("Semester calendar listener failed", error)
        installSemesterCalendar(null)
      }
    )
  }, [])
}
